import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { AmountToPay } from 'account/amount-to-pay/amount-to-pay';
import { AmountToPayLayout } from 'account/amount-to-pay/amount-to-pay.store';
import { Notice } from 'action/components/notice/notice';
import { ButtonType } from 'components/buttons/button-types';
import { FeatureFlag } from 'core/enums/feature-flag';
import { SanitizeHTML } from 'shared/components/html-sanitizer';
import { CampaignPopupStore } from '../campaign-popup.store';
import { PopupStore } from '../popup.store';
import styles from '../popup.module.scss';

type Props = {
  popupStore: PopupStore;
  store: CampaignPopupStore;
};

export const CampaignPopup = observer<Props>(({ popupStore, store }) => {
  const { isPremium, currentCampaign } = store;
  const { body, payButton, premiumBody, name } = currentCampaign;
  const { t } = useTranslation();

  if (!body && !premiumBody) {
    return (
      <Notice
        padding
        heading={t('rewards.error.header')}
        button={{ title: 'buttons.close', name: 'close', type: ButtonType.Primary }}
      />
    );
  }

  const bodyToUse = isPremium ? premiumBody : body;
  const nameToUse = isPremium ? name + "_premium" : name;

  return (
    <div className={styles.genericPopup}>
      <SanitizeHTML
        html={bodyToUse}
        options={{
          allowedTags: ['img', 'div'],
          allowedAttributes: { img: ['src', 'alt', 'class', 'style'], div: ['class', 'style'] },
        }}
      />
      {payButton ? (
        <AmountToPay
          layout={AmountToPayLayout.Button}
          customAreaName={nameToUse}
          customComponentName={`${nameToUse}_detail_model`}
          analyticsEntryPoint={`${nameToUse}_campaign`}
          customJourneyName={FeatureFlag.DashboardGenericPopupCampaigns}
        />
      ) : null}
    </div>
  );
});